"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sellia-marina": {
    "2ce8540f": [{
      "hkey": "0fff5889",
      "slug": "sellia-marina",
      "name": "Sellia Marina",
      "primary": true,
      "skipSearch": false
    }],
    "calabricata": [{
      "hkey": "0fff5889",
      "slug": "sellia-marina",
      "name": "Sellia Marina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "707505ad": [{
      "hkey": "0fff5889",
      "slug": "sellia-marina",
      "name": "Sellia Marina",
      "primary": true,
      "skipSearch": false
    }],
    "chiaro": [{
      "hkey": "0fff5889",
      "slug": "sellia-marina",
      "name": "Sellia Marina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1515588a": [{
      "hkey": "0fff5889",
      "slug": "sellia-marina",
      "name": "Sellia Marina",
      "primary": true,
      "skipSearch": false
    }],
    "cipollina": [{
      "hkey": "0fff5889",
      "slug": "sellia-marina",
      "name": "Sellia Marina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8d5861d6": [{
      "hkey": "0fff5889",
      "slug": "sellia-marina",
      "name": "Sellia Marina",
      "primary": true,
      "skipSearch": false
    }],
    "finocchiara": [{
      "hkey": "0fff5889",
      "slug": "sellia-marina",
      "name": "Sellia Marina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8aa0eac7": [{
      "hkey": "0fff5889",
      "slug": "sellia-marina",
      "name": "Sellia Marina",
      "primary": true,
      "skipSearch": false
    }],
    "frasso": [{
      "hkey": "0fff5889",
      "slug": "sellia-marina",
      "name": "Sellia Marina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "daa5efaf": [{
      "hkey": "0fff5889",
      "slug": "sellia-marina",
      "name": "Sellia Marina",
      "primary": true,
      "skipSearch": false
    }],
    "grandini": [{
      "hkey": "0fff5889",
      "slug": "sellia-marina",
      "name": "Sellia Marina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b649d233": [{
      "hkey": "0fff5889",
      "slug": "sellia-marina",
      "name": "Sellia Marina",
      "primary": true,
      "skipSearch": false
    }],
    "pirarella": [{
      "hkey": "0fff5889",
      "slug": "sellia-marina",
      "name": "Sellia Marina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dcfd598c": [{
      "hkey": "0fff5889",
      "slug": "sellia-marina",
      "name": "Sellia Marina",
      "primary": true,
      "skipSearch": false
    }],
    "rocca": [{
      "hkey": "0fff5889",
      "slug": "sellia-marina",
      "name": "Sellia Marina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9e2577d4": [{
      "hkey": "0fff5889",
      "slug": "sellia-marina",
      "name": "Sellia Marina",
      "primary": true,
      "skipSearch": false
    }],
    "san-vincenzo": [{
      "hkey": "0fff5889",
      "slug": "sellia-marina",
      "name": "Sellia Marina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;